import type { SlotProps } from "@radix-ui/react-slot";
import { cn } from "@acdc2/ui/lib/utils";
import { Slot } from "@radix-ui/react-slot";
import { Moveable } from "../ui/Moveable";

type Props = SlotProps & {
  isSelected: boolean;
  onMove: (movementX: number, movementY: number) => void;
  onDone: () => void;
};

export function RegionMoveHandler({
  isSelected,
  onMove,
  onDone,
  children,
  className,
  ...props
}: Props) {
  return (
    <Slot {...props}>
      <Moveable
        onMove={onMove}
        onDone={onDone}
        disabled={!isSelected}
        tabIndex={0}
        className={cn(
          "focus:cursor-grab [&.is-dragged]:cursor-grabbing",
          className,
        )}
      >
        {children}
      </Moveable>
    </Slot>
  );
}
